import React, { useEffect, useMemo, useState, useRef, createElement } from 'react';
import { Link } from 'react-router-dom';
import { SiteNavLinks } from '../components/SiteNavLinks';
const CENTER_IMAGE = 'https://cdn.magicpatterns.com/uploads/n2kNJrXXN5jB9ACfPQhrbc/Still_2026-06-02_012807_2.1.3.jpg';
const PERIL_WORD = 'constant peril';
const COLS = 8;
const ROWS = 30;
const TOTAL_SLOTS = COLS * ROWS;
const TICK_MS = 18;
function shuffle<T>(arr: T[]): T[] {
  const out = arr.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}
export function Home() {
  // Easter egg state
  const [isPerilActive, setIsPerilActive] = useState(false);
  const [visible, setVisible] = useState<boolean[]>(() => new Array(TOTAL_SLOTS).fill(false));
  const revealOrderRef = useRef<number[]>([]);
  const tickRef = useRef<ReturnType<typeof setInterval> | null>(null);
  // Load the Laylo SDK once on mount so the embed renders
  useEffect(() => {
    const SRC = 'https://embed.laylo.com/laylo-sdk.js';
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
  const handleImageClick = () => {
    if (isPerilActive) {
      if (tickRef.current) clearInterval(tickRef.current);
      tickRef.current = null;
      setIsPerilActive(false);
      setVisible(new Array(TOTAL_SLOTS).fill(false));
    } else {
      revealOrderRef.current = shuffle(Array.from({
        length: TOTAL_SLOTS
      }, (_, i) => i));
      setVisible(new Array(TOTAL_SLOTS).fill(false));
      setIsPerilActive(true);
    }
  };
  useEffect(() => {
    if (!isPerilActive) return;
    let step = 0;
    tickRef.current = setInterval(() => {
      if (step >= revealOrderRef.current.length) {
        if (tickRef.current) clearInterval(tickRef.current);
        tickRef.current = null;
        return;
      }
      const idx = revealOrderRef.current[step];
      step += 1;
      setVisible(prev => {
        const next = prev.slice();
        next[idx] = true;
        return next;
      });
    }, TICK_MS);
    return () => {
      if (tickRef.current) {
        clearInterval(tickRef.current);
        tickRef.current = null;
      }
    };
  }, [isPerilActive]);
  const slotIndices = useMemo(() => Array.from({
    length: TOTAL_SLOTS
  }, (_, i) => i), []);
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-225" data-mp="1tlf2edho2ksy">
      {/* Top Header */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-226" data-mp="2m8hy6xuykhfi">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-227" data-mp="2r1kuvev186zx">
          lennon cripe
        </Link>

        <SiteNavLinks data-id="element-228" data-mp="fkixp27eeuq6" />

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-229" data-mp="fjpolukyvt4v">
          contact
        </a>
      </header>

      {/* Cover art with easter egg */}
      <section className="mt-16 flex w-full justify-center md:mt-24" data-id="element-230" data-mp="og8fl19n16yt">
        <button onClick={handleImageClick} aria-label="Toggle constant peril" className="relative -mx-6 block w-[calc(100%+3rem)] max-w-none md:mx-0 md:w-[800px] md:max-w-full" style={{
        cursor: 'pointer'
      }} data-id="element-231" data-mp="kdtxijdsmb8l">
          <img src={CENTER_IMAGE} alt="Cover art" className="h-auto w-full" style={{
          mixBlendMode: 'multiply'
        }} draggable={false} data-id="element-232" data-mp="5nwe0gqt69pq" />

          {isPerilActive && <div className="absolute inset-0 overflow-hidden bg-[#f5f5f5]" style={{
          fontFamily: '"Courier New", Courier, "SFMono-Regular", Menlo, Monaco, monospace',
          fontSize: '11px',
          lineHeight: '1',
          color: 'black',
          display: 'grid',
          gridTemplateColumns: `repeat(${COLS}, 1fr)`,
          gridTemplateRows: `repeat(${ROWS}, 1fr)`
        }} data-id="element-233" data-mp="1h4mbnbh61t7q">
              {slotIndices.map(i => <span key={i} className="flex items-center justify-center lowercase" style={{
            visibility: visible[i] ? 'visible' : 'hidden'
          }} data-id="element-234" data-mp="2qbzevhr3002j">
                  {PERIL_WORD}
                </span>)}
            </div>}
        </button>
      </section>

      {/* Sign up — Laylo embed */}
      <section className="mt-16 flex w-full flex-col items-center justify-center pb-24 text-sm md:mt-24" data-id="element-235" data-mp="3a2kyqwo6pusa">
        <div className="w-full max-w-md" data-id="element-236" data-mp="3e08w06dcnznc">
          <iframe id="laylo-drop-4ekga" frameBorder="0" scrolling="no" allow="web-share" allowTransparency title="Sign up" style={{
          width: '1px',
          minWidth: '100%',
          maxWidth: '1000px'
        }} src="https://embed.laylo.com?dropId=4ekga&color=000000&minimal=true&theme=light&background=transparent&customTitle=sign%20up" data-id="element-237" data-mp="12fhu54ewt970" />
        </div>
      </section>
    </main>;
}